export default "__VITE_ASSET__qI7VGCsa__"